import {
  AppBar,
  Avatar,
  Badge,
  Divider,
  Fade,
  Grid,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

// import LabelDisplay from "../../FrontEnd/UpdateChange/LabelDisplay";
import logo from "../../images/logo.jpeg";
// import WSCustomBreadcrumbs from "../BreadCrumbs/BreadCrumbsComp";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useAuth } from "../../Context/AuthContext";
import { getValue, LoacalVariables } from "../../commonFunctions/CommonFunctions";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const Navbar: React.FC = () => {
  const [profileAnchor, setProfileAnchor] = useState<null | HTMLElement>(null);

  const { handleLogout } = useAuth();
  const userName: any = getValue(LoacalVariables.Name);
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <AppBar
      elevation={0}
      position="fixed"
      sx={{
        width: "100%",
        mt: 1,
        bgcolor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 3,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ minHeight: 64 }}>

        <Grid container alignItems="center" justifyContent="space-between">

          {/* Logo */}
          <Grid item xs={12} sm={1}>
            <img
              src={logo}
              style={{
                width: "2.8rem",
                border: `2px solid ${theme.palette.primary.main}`,
                borderRadius: 20,
              }}
            />
          </Grid>

          {/* Greeting + Breadcrumb */}
          {/* <Grid item xs={12} sm={7}>
            <LabelDisplay />
            <WSCustomBreadcrumbs />
          </Grid> */}

          {/* Right Controls */}
          <Grid item xs={12} sm={3}>
            <Stack direction="row" alignItems="center" spacing={2} justifyContent="flex-end">

              {/* Profile Trigger */}
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{
                  px: 1.5,
                  py: 0.8,
                  borderRadius: 2,
                  border: `1px solid ${theme.palette.primary.main}`,
                  cursor: "pointer",
                  transition: "all .2s",
                  "&:hover": {
                    backgroundColor: theme.palette.primary.main + "15",
                  },
                }}
                onClick={(e) => setProfileAnchor(e.currentTarget)}
              >
                <Avatar
                  sx={{
                    width: 28,
                    height: 28,
                    bgcolor: theme.palette.primary.main,
                    fontSize: 14
                  }}
                >
                  {userName?.charAt(0)}
                </Avatar>

                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: theme.palette.text.primary,
                  }}
                >
                  {userName}
                </Typography>
              </Stack>

            </Stack>
          </Grid>

        </Grid>
      </Toolbar>

      {/* Profile Menu */}
      <Menu
        anchorEl={profileAnchor}
        open={Boolean(profileAnchor)}
        onClose={() => setProfileAnchor(null)}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >

        <MenuItem
          onClick={() => {
            setProfileAnchor(null);
            navigate(`/settings/business-details/${userName}`);
          }}
        >
          <WSIcons.User sx={{ mr: 1 }} />
          Profile
        </MenuItem>

        <MenuItem onClick={() => {
          setProfileAnchor(null);
          navigate("/about-us")
        }}>
          <WSIcons.About sx={{ mr: 1 }} />
          About
        </MenuItem>

        <Divider />

        <MenuItem
          onClick={() => {
            setProfileAnchor(null);
            handleLogout();
          }}
        >
          <WSIcons.LogOut sx={{ mr: 1, color: theme.palette.error.main }} />
          Logout
        </MenuItem>

      </Menu>

    </AppBar>
  );
};

export default Navbar;